<template>
    <div v-if="userInfo && canSysAdmin(userInfo)">
        <div ref="controllButtons" v-resize="onResize">
            <b-button-group size="sm">
                <b-button type="button" variant="light" @click="activateIndex = 0">JSON</b-button>
                <b-button type="button" variant="light" @click="activateIndex = 1">Sheet</b-button>
            </b-button-group>
            <button type="button" class="btn btn-primary btn-sm " @click="getMenuActive">Current</button>
            <button type="button" class="btn btn-danger btn-sm mx-1" @click="errorCheck">Error Check</button>
            
            <button type="button" class="btn btn-dark btn-sm" @click="previewMenu">Preview</button>

            <button type="button" class="btn btn-warning btn-sm mx-1" @click="updateMenu">Update Menu</button>
            <button type="button" class="btn btn-info btn-sm mx-1" @click="undoMenu" v-if="modified">Undo</button>

            <button type="button" class="btn btn-success btn-sm " @click="publishMenu" v-if="modified">Publish</button>
            <b-icon style="cursor: pointer;" variant="primary" font-scale="1.5"
                    class="d-inline-block mx-2" icon="file-earmark-spreadsheet"  @click="downloadCSV"/>
            <input class="input-sm d-inline-block float-right" type="file" @change="importCsvFile">
        </div>       
        <div>
            <div v-show="activateIndex === 0">
                <b-form-textarea
                    v-model="menuJsonString"
                    placeholder="Write Your Json"
                    rows="20" />
            </div>
            <div v-show="activateIndex === 1">                    
                <div id="spreadsheet" ref="spreadsheet" class="sheet cell"></div>                     
            </div>
        </div>
        <p class="error" v-if="error.length > 0">{{JSON.stringify(error,  null, 4)}}</p>
    </div>
    <b-container v-else>
        You dont have access Menu Editor
    </b-container>    
</template>
<script>
import { mapState } from 'vuex'

import Swal from 'sweetalert2'

import jexcelStyle from "jexcel/dist/jexcel.css"; // eslint-disable-line no-unused-vars
import jexcel from "jexcel"; // eslint-disable-line no-unused-vars
import moment from 'moment'
import resize from 'vue-resize-directive'
    
//Sheet Map
const SMAP = Object.freeze({                                        
                                section_title : { key : "title" , column : 0 , title : "(Sections) Title", type: "text"},
                                
                                item_title : { key : "title" , column : 1 , title : "(Items) Title", type: "text"},
                                item_sn : { key : "shortName" , column : 2 , title : "Short Name", type: "text"},
                                item_desc : { key : "description" , column : 3 , title : "Description", type: "text"},
                                item_price : { key : "price" , column : 4 , title : "Price", type: "numeric"},
                                item_info : { key : "info" , column : 5 , title : "Info", type: "text"},
                                item_always : { key : "alwaysAvailable" , column : 6 , title : "alwaysAvailable", type: "checkbox"},
                                item_hours : { key : "hours" , column : 7 , title : "hours", type: "text"},
                                item_media : { key : "media" , column : 8 , title : "Media" , type: "text"},

                                og_title : { key : "title" , column : 9 , title : "(optionGroups) Title", type: "text"},
                                og_min : { key : "choiceMin" , column : 10 , title : "min", type: "numeric"},
                                og_max : { key : "choiceMax" , column : 11 , title : "max", type: "numeric"},
                                og_duplicate : { key : "duplicates" , column : 12 , title : "duplicates", type: "checkbox"},

                                option_title : { key : "title" , column : 13 , title : "Options", type: "text"},
                                option_sn : { key : "shortName" , column : 14 , title : "Short Name", type: "text"},
                                option_price : { key : "price" , column : 15 , title : "price", type: "numeric"},
                                option_trackable : { key : "trackable" , column : 16 , title : "trackable", type: "checkbox"},
                                option_preselect : { key : "preselect" , column : 17 , title : "preselect", type: "checkbox"},
                          })

//Json Map
const JMAP = Object.freeze({
                            section : { ignore : true, start : 0, end : 1 },
                            item : { ignore : true, start : 1, end : 9 },
                            og : { ignore : true, start : 9, end : 13 },
                            option : { ignore : true, start : 13, end : 18 },
                          })

export default {
    components: { },
    data(){
        return {
            modified:false,
            activateIndex:0,
            jExcelObj : null,
            tableWidth : 1000,
            tableHeight : 500,
            error : [],
            sheetJson : [],
            menuJsonString : '',
        }
    },
    watch:{
        activateIndex(){
            switch(this.activateIndex){
                case 0:
                    this.changeToJson()
                break;
                case 1:
                    this.changeToSheet()
                break;                    
            }
        },
        selectedLocation: {
            deep: true,
            immediate: true,
            handler() {
                this.menuJsonString = null
                this.getMenuActive(); 
            }
        }  
    },
    directives: {
        resize,
    },
    computed: { 
		...mapState({
            store: 'store',
            selectedLocation:'selectedLocation',
            userInfo:'userInfo'
        }),
        jExcelOptions() {
            let columns = []
            
            Object.entries(SMAP).forEach(([, value])=>{
                const {type, title} = value
                let column = {}
                column["title"] = title
                switch(type){
                    case "text":
                        column["type"] = "text"
                        column["width"] = "150px"                                
                    break;
                    case "numeric":
                        column["type"] = "numeric"                        
                    break;
                    case "checkbox":
                        column["type"] = "checkbox"                        
                    break;                                        
                }
                columns.push(column)
            })
            return {
                    data: this.sheetJson,
                    columns: columns,
                    rowResize: false,
                    csvHeaders:false,
                    tableOverflow: true,
                    tableWidth: `${this.tableWidth}px`,   
                    tableHeight: `${this.tableHeight}px`,
                    allowExport: false,
                };
        }
    },
    methods:{
        /* eslint-disable */
        changeToCSV(json){
            let sections = json.sections
            let sheetRows = []
            {
                let row = []
                for(let i = 0; i < Object.values(SMAP).length; i++){
                    row.push(Object.values(SMAP)[i].title)
                }
                sheetRows.push(row)
            }
            sections.forEach(({title, items})=>{
                {
                    let row = []
                    row.push(sQD(title))//	0
                    for(let i = JMAP.section.end; i < JMAP.option.end; i++){
                        row.push("")
                    }
                    sheetRows.push(row.join(","))
                }
                items.forEach(({title, shortName, description, price, info, alwaysAvailable, hours, media, optionGroups})=>{
                    {
                        let row = []
                        for(let i = JMAP.section.start; i < JMAP.item.start; i++){
                            row.push("")
                        }
                        row.push(sQD(title))//	SMAP.item_title
                        row.push(sQD(shortName))//	SMAP.item_sn
                        row.push(sQD(description))//	SMAP.item_desc
                        row.push(price / 100.0)//	SMAP.item_price
                        row.push(sQD(info))//	SMAP.item_info
                        row.push(alwaysAvailable)//	SMAP.item_always

                        if(hours){
                            let cloumnHours = ""
                            let keys = Object.keys(hours);
                            let days = []
                            keys.forEach((key)=>{						
                                let dayHour = []
                                hours[key].forEach((hour)=>{
                                    dayHour.push(hour.startTime+'-'+hour.endTime)	
                                })
                                days.push(key + " "+ dayHour.join(" * "))						
                            })
                            cloumnHours = days.join(" | ")
                            row.push(cloumnHours)  //	SMAP.item_hours
                        } else {
                            row.push("") //	SMAP.item_hours
                        }
                        let _media = media
                        try{
                           _media = media._id || media
                        }catch(_){ }
                        row.push(sQD(_media))

                        for(let i = JMAP.item.end; i < JMAP.option.end; i++){
                            row.push("")
                        }			
                        sheetRows.push(row.join(","))
                    }
                    optionGroups.forEach(({title, choiceMin, choiceMax, duplicates, options})=>{
                        {
                            let row = []
                            for(let i = JMAP.section.start; i < JMAP.og.start; i++){
                                row.push("")
                            }
                            row.push(sQD(title))//	SMAP.og_title
                            row.push(choiceMin)//	SMAP.og_min
                            row.push(choiceMax)//	SMAP.og_max
                            row.push(duplicates)//	SMAP.og_duplicate 

                            for(let i = JMAP.og.end; i < JMAP.option.end; i++){
                                row.push("")
                            }			
                            sheetRows.push(row.join(","))
                        }
                        options.forEach(({title, shortName, price, trackable, preselect})=>{
                            {
                                let row = []
                                for(let i = JMAP.section.start; i < JMAP.option.start; i++){
                                    row.push("")
                                }
                                row.push(sQD(title))//	SMAP.option_title
                                row.push(sQD(shortName))//	SMAP.option_sn
                                row.push(price / 100.0)//	SMAP.option_price
                                row.push(trackable)//	SMAP.option_price
                                row.push(preselect)//	SMAP.option_preselect			
                                
                                sheetRows.push(row.join(","))
                            }
                        })
                    })
                })
            })
            return sheetRows.join('\n')
        },
        /* eslint-disable */
        changeToSheet(){
            let sections = []
            try{
                sections = JSON.parse(this.menuJsonString).sections
            }catch{
                return
            }
            let sheetRows = []

            sections.forEach(({title, items})=>{
                {
                    let row = []
                    row.push(rDQ(title))//	SMAP.section_title                    
                    for(let i = JMAP.section.end; i < JMAP.option.end; i++){
                        row.push("")
                    }
                    sheetRows.push(row)
                }
                items.forEach(({title, shortName, description, price, info, alwaysAvailable, hours, media, optionGroups})=>{
                    {
                        let row = []
                        for(let i = JMAP.section.start; i < JMAP.item.start; i++){
                            row.push("")
                        }
                        row.push(rDQ(title))//	SMAP.item_title
                        row.push(rDQ(shortName))//	SMAP.item_sn
                        row.push(rDQ(description))//	SMAP.item_desc
                        row.push(price / 100.0)//	SMAP.item_price
                        row.push(rDQ(info))//	        SMAP.item_info
                        row.push(alwaysAvailable)//     SMAP.item_always

                        let cloumnHours = ""
                        if(hours){
                            let keys = Object.keys(hours);
                            let days = []                            
                            keys.forEach((key)=>{						
                                let dayHour = []
                                hours[key].forEach((hour)=>{
                                    dayHour.push(hour.startTime+'-'+hour.endTime)	
                                })
                                days.push(key + " "+ dayHour.join(" * "))						
                            })
                            cloumnHours = days.join(" | ")
                        }
                        row.push(cloumnHours)	
                        
                        let _media = media
                        try{
                           _media = media._id || media
                        }catch(_){ }
                        row.push(rDQ(_media))

                        for(let i = JMAP.item.end; i < JMAP.option.end; i++){
                            row.push("")
                        }			
                        sheetRows.push(row)
                    }
                    optionGroups.forEach(({title, choiceMin, choiceMax, duplicates, options})=>{
                        {
                            let row = []
                            for(let i = JMAP.section.start; i < JMAP.og.start; i++){
                                row.push("")
                            }
                            row.push(rDQ(title))//	SMAP.og_title
                            row.push(choiceMin)//	SMAP.og_min
                            row.push(choiceMax)//	SMAP.og_max
                            row.push(duplicates)//	SMAP.og_duplicate 

                            for(let i = JMAP.og.end; i < JMAP.option.end; i++){
                                row.push("")
                            }			
                            sheetRows.push(row)
                        }
                        options.forEach(({title, shortName, price, trackable, preselect})=>{
                            {
                                let row = []
                                for(let i = JMAP.section.start; i < JMAP.option.start; i++){
                                    row.push("")
                                }
                                row.push(rDQ(title))//	SMAP.option_title
                                row.push(rDQ(shortName))//	SMAP.option_sn
                                row.push(price / 100.0)//	SMAP.option_price
                                row.push(trackable)//	SMAP.option_price
                                row.push(preselect)//	SMAP.option_preselect		
                                
                                sheetRows.push(row)
                            }
                        })
                    })
                })
            })
            this.sheetJson = sheetRows
            this.mountSheet()
            //console.log("SheetRows", JSON.stringify(sheetRows))
        },
        getHours(_object, index, format) {
            let hours = {}
            daysName.forEach((_day)=>{
                hours[_day] = []
            })
            let stringHours = _object.split('|')
            stringHours.forEach((sH)=>{
                try{
                    let dayName = daysName.find((day)=>{
                      return sH.toLowerCase().trim().startsWith(day.toLowerCase().trim())
                    })

                    let dayHours = []
                    try{
                        dayHours = sH.toLowerCase().replace(dayName, "").trim().split('*')
                    }catch(de){
                        this.error.push("Row empty hours " + (index + 1) + de)
                    }
                    dayHours.forEach((dayHour)=>{
                        try{
                            let sT = dayHour.split("-")[0].trim().replace(/ /g,'')
                            let eT = dayHour.split("-")[1].trim().replace(/ /g,'')

                            let startTime = moment(sT, ['h:ma', 'ha'])
                            let endTime = moment(eT, ['h:ma', 'ha'])
                            let hour = new Object()
                            if(endTime.isAfter(startTime)){
                                if(format){
                                    hour["startTime"] = startTime.format("hh:mma")
                                    hour["endTime"] = endTime.format("hh:mma")
                                }else{
                                    hour["startTime"] = startTime.toDate()
                                    hour["endTime"] = endTime.toDate()
                                }
                                hours[dayName].push(hour)
                            }else{
                                if(format){
                                    hour["startTime"] = startTime.format("hh:mma")
                                    hour["endTime"] = endTime.add(1, 'days').format("hh:mma")
                                }else{
                                    hour["startTime"] = startTime.toDate()
                                    hour["endTime"] = endTime.add(1, 'days').toDate()
                                }
                                hours[dayName].push(hour)
                            }
                        }catch(he){
                            this.error.push("Error he - Row " + " " + (index + 1) + "  " + dayName + " " + he)
                        }
                    })
                }catch(eSH){
                    this.error.push("Error eSH - Row " + (index + 1) + eSH)
                }                			
            })			                    
            return hours
        },
        validateHours(hours, index){
            let accumulateHours = []		
            {
                let sunday = hours[daysName[6]]
                sunday.forEach((time)=>{
                    let firstSunday = new Object();
                    firstSunday["startTime"] = moment(time.startTime).subtract(moment().weekday(), 'days').toDate()
                    firstSunday["endTime"] = moment(time.endTime).subtract(moment().weekday(), 'days').toDate()
                    accumulateHours.push(firstSunday)	
                })

                daysName.forEach((_day)=>{
                    hours[_day].forEach((time)=>{
                        time.startTime = moment(time.startTime).subtract(moment().weekday(), 'days').add(moment(_day, "dddd").isoWeekday(), 'days').toDate()
                        time.endTime = moment(time.endTime).subtract(moment().weekday(), 'days').add(moment(_day, "dddd").isoWeekday(), 'days').toDate()
                        accumulateHours.push(time)	
                    })
                })		
                                
                accumulateHours.sort((a, b)=>{
                    return moment(a.startTime).diff(moment(b.startTime))
                })
                //console.log(accumulateHours)
            }
            
            {
                if(accumulateHours.length >= 2){
                    let lastHour = accumulateHours[0]
                    for(var i = 1 ; i < accumulateHours.length; i++){
                        let hour = accumulateHours[i]	
                        if(!(moment(hour.startTime).isAfter(moment(lastHour.endTime)))){
                            this.error.push("Row " + (index + 1) + " 's hour " + hour.startTime + " - " + lastHour.endTime + " Overlapping")
                        }
                        lastHour = hour
                    }
                }	
                
                hours = {}
                daysName.forEach((_day)=>{
                    hours[_day] = []
                })			
                accumulateHours.forEach((_dt)=>{
                    let mS = moment(_dt.startTime)
                    let mE = moment(_dt.endTime)
                    
                    let dOw = new Object()
                    dOw["startTime"] = mS.format("hh:mma")
                    dOw["endTime"] = mE.format("hh:mma")
                    if(!(mS.format("dddd").toLowerCase() === daysName[6] && moment().isAfter(mS))){
                        hours[mS.format("dddd").toLowerCase()].push(dOw)
                    }
                })
            }
        },
        changeToJson() {            
            var allTextLines = this.sheetJson;
            let sections = [];
            let section, item, optionGroup;
            this.error = [];
		
            allTextLines.forEach((line, index) => {
                {			
                    var entries = line;
                    
                    if(entries[JMAP.section.start]) {
                        section = new Object()				
                        section["title"] = entries[SMAP.section_title.column] //String
                        section["items"] = []		  //Array
                        sections.push(section)

                        let canItCause = false
                        for(let i = JMAP.section.end; i < JMAP.option.end ; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has item")
                            //return
                        }
                    }else if(entries[JMAP.item.start]){
                        item = new Object()
                        item["title"] = entries[SMAP.item_title.column]		//String
                        item["shortName"] = entries[SMAP.item_sn.column]	//String
                        item["description"] = entries[SMAP.item_desc.column]//String
                        try{
                            item["media"] = entries[SMAP.item_media.column]
                        }catch(_){
                            item["media"] = null;
                        }
                        try{
                            item["price"] = Math.round(parseFloat(entries[SMAP.item_price.column]) * 100)			//Float
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column price " + e)
                        }

                        item["info"] = entries[SMAP.item_info.column]		//String
                        
                        item["alwaysAvailable"] = parseBool(entries[SMAP.item_always.column])                            
                        try{                            
                            item["hours"] =  this.getHours(entries[SMAP.item_hours.column], index, true)
                        }catch(e){                           
                            this.error.push("Row " + (index + 1) + "=> Column alwaysAvailable " + e)
                        }

                        item["optionGroups"] = []
                        section.items.push(item)
                        
                        let canItCause = false
                        for(let i = JMAP.item.end; i < JMAP.option.end; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has optionGroup")
                            //return
                        }
                    }else if(entries[JMAP.og.start]){
                        optionGroup = new Object()
                        optionGroup["title"] = entries[SMAP.og_title.column]		//String
                        try{
                            optionGroup["choiceMin"] = parseInt(entries[SMAP.og_min.column])	//Number				
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column choiceMin " + e)
                        }
                        try{
                            optionGroup["choiceMax"] = parseInt(entries[SMAP.og_max.column])	//Number
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column choiceMax " + e)
                        }
                        try{
                            optionGroup["duplicates"] = parseBool(entries[SMAP.og_duplicate.column])	//Boolean
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column duplicates " + e)
                        }
                        optionGroup["options"] = []	//Array				
                        
                        item.optionGroups.push(optionGroup)
                        
                        let canItCause = false
                        for(let i = JMAP.og.end; i < JMAP.option.end; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has option")
                            //return
                        }
                    }else if(entries[JMAP.option.start]){
                        var option = new Object()				
                        option["title"] = entries[SMAP.option_title.column]		//String
                        option["shortName"] = entries[SMAP.option_sn.column]	//String	
                        try{
                            option["price"] = Math.round(parseFloat(entries[SMAP.option_price.column]) * 100)		//Float
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column price " + e)
                        }
                        try{
                            option["trackable"] = parseBool(entries[SMAP.option_trackable.column])	//Boolean	
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column trackable " + e)
                        }
                        try{					
                            option["preselect"] = parseBool(entries[SMAP.option_preselect.column])	//Boolean
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column preselect " + e)
                        }
                        
                        optionGroup.options.push(option)
                    } else {
                        this.error.push("Row " + (index + 1))
                    }
                }
            })		
    		let menuData = new Object()
            menuData["sections"] = sections
            this.menuJsonString = JSON.stringify(menuData,  null, 4)
            jexcel.destroy(this.$refs["spreadsheet"], false)
        },
        mountSheet(){
            jexcel.destroy(this.$refs["spreadsheet"], false)
            let jExcelObj = jexcel(this.$refs["spreadsheet"], this.jExcelOptions);            
            this.jExcelObj = jExcelObj
            Object.assign(this, { jExcelObj }); 
        },
        refresh(){
            jexcel.destroy(this.$refs["spreadsheet"], false)
            this.mountSheet()
        },
        importCsvFile(event){
            let input = event.target.files[0]
            if(input){
                var fr=new FileReader(); 
                fr.onload=()=>{ 
                   this.processCSVFileData(fr.result)
                }               
                fr.readAsText(input);
            }
        },
        getMenuActive() {
            this.$store.dispatch('apiMenuActive')
                    .then(({status, res}) => {
                            if(status){
                                this.modified = res.modified
                                this.menuJsonString = JSON.stringify(res,  null, 4)                    
                                jexcel.destroy(this.$refs["spreadsheet"], false)
                                this.changeToSheet()
                            }
                        })
                    .catch(e=>{
                           console.log("apiMenuActive-E", e)                        
                    })
        },
        errorCheck(){
           this.error = []
           if(this.activateIndex === 0){
                this.changeToSheet()
                this.changeToJson()
           }else{
                this.changeToJson()
                this.changeToSheet()
           }

           let menuObject = JSON.parse(this.menuJsonString)
            
            let sections = menuObject.sections
            try{
                sections.forEach(({title, items}) => {
                    try{
                        items.forEach(({title, alwaysAvailable, hours})=>{
                            if(!alwaysAvailable){
                                try{
                                    let cloumnHours = ""
                                    if(hours){
                                        let keys = Object.keys(hours);
                                        let days = []
                                        keys.forEach((key)=>{						
                                            let dayHour = []
                                            hours[key].forEach((hour)=>{
                                                dayHour.push(hour.startTime+'-'+hour.endTime)	
                                            })
                                            days.push(key + " "+ dayHour.join(" * "))						
                                        })
                                        cloumnHours = days.join(" | ")
                                        this.validateHours(this.getHours(cloumnHours, '', false), '') 
                                    }                                    
                                }catch(he){
                                    this.error.push("item's Hour " + title + " " + he)                                    
                                }
                            }
                        })
                    }catch(ie){
                        this.error.push("Item " + title + " " +ie)
                    }
                })
            }catch(se){
                this.error.push("Sections " + se)
            }
        },
        updateMenu(){
            if(this.activateIndex === 0){
                this.changeToSheet()
                this.changeToJson()
            }else{
                this.changeToJson()
                this.changeToSheet()
            }
            this.$store.dispatch('apiMenuActiveSave', JSON.parse(this.menuJsonString))
                        .then(({status, res}) => {
                            if(status){
                                this.modified = true
                                Swal.fire(
                                'Updated',
                                'Menu has been updated.',
                                'success')
                            }
                        })
                        .catch(e=>{
                             Swal.fire('Error', e, 'error')
                        })
        },
        publishMenu(){
          //  this.$store.dispatch('apiMenuActive')
        },
        processCSVFileData(allText) {
            var allTextLines = allText.split(/\r\n|\n/);
            let sections = [];
            let section, item, optionGroup;
            this.error = [];

            allTextLines.forEach((line, index)=>{
                if(index > 0){			//0 has header
                    var entries = line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
                    // if(entries.length !== 17){
                    //     this.error.push("Row " + (index + 1) + " has comma seperated or invalid")
                    // }
                    
                    if(entries[JMAP.section.start]) {
                        section = new Object()				
                        section["title"] = entries[SMAP.section_title.column] //String
                        section["items"] = []		  //Array
                        sections.push(section)

                        var canItCause = false
                        for(var i = JMAP.section.end; i < JMAP.option.end ; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has item")
                            //return
                        }
                    }else if(entries[JMAP.item.start]){
                        item = new Object()
                        item["title"] = entries[SMAP.item_title.column]		//String
                        item["shortName"] = entries[SMAP.item_sn.column]	//String
                        item["description"] = entries[SMAP.item_desc.column]//String                        
                        item["media"] = entries[SMAP.item_media.column]

                        try{
                            item["price"] = Math.round(parseFloat(entries[SMAP.item_price.column]) * 100)			//Float
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column price " + e)
                        }
                        item["info"] = entries[SMAP.item_info.column]		//String
                        item["alwaysAvailable"] = parseBool(entries[SMAP.item_always.column])

                        try{
                            item["hours"] = this.getHours(entries[SMAP.item_hours.column], index, true);	
                        }catch(e){
                           this.error.push("Row " + (index + 1) + "=> Column Hours " + e)
                        }
                        item["optionGroups"] = []
                        section.items.push(item)
                        
                        let canItCause = false
                        for(let i = JMAP.item.end; i < JMAP.option.end; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has optionGroup")
                           // return
                        }
                    }else if(entries[JMAP.og.start]){
                        optionGroup = new Object()
                        optionGroup["title"] = entries[SMAP.og_title.column]		//String
                        try{
                            optionGroup["choiceMin"] = parseInt(entries[SMAP.og_min.column])	//Number				
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column choiceMin " + e)
                        }
                        try{
                            optionGroup["choiceMax"] = parseInt(entries[SMAP.og_max.column])	//Number
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column choiceMax " + e)
                        }
                        try{
                            optionGroup["duplicates"] = parseBool(entries[SMAP.og_duplicate.column])	//Boolean
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column duplicates " + e)
                        }
                        optionGroup["options"] = []	//Array				
                        
                        item.optionGroups.push(optionGroup)
                        
                        let canItCause = false
                        for(let i = JMAP.og.end; i < JMAP.option.end; i++){
                            if(entries[i]){
                                canItCause = true
                                break
                            }
                        }
                        if(canItCause){
                            console.error("Row " + (index + 1) + " has option")
                            //return
                        }
                    }else if(entries[JMAP.option.start]){
                        var option = new Object()				
                        option["title"] = entries[SMAP.option_title.column]		//String
                        option["shortName"] = entries[SMAP.option_sn.column]	//String	
                        try{
                            option["price"] = Math.round(parseFloat(entries[SMAP.option_price.column]) * 100)		//Float
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column price " + e)
                        }
                        try{
                            option["trackable"] = parseBool(entries[SMAP.option_trackable.column])	//Boolean	
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column trackable " + e)
                        }
                        try{					
                            option["preselect"] = parseBool(entries[SMAP.option_preselect.column])	//Boolean
                        }catch(e){
                            this.error.push("Row " + (index + 1) + "=> Column preselect " + e)
                        }
                        
                        optionGroup.options.push(option)
                    } else {
                        this.error.push("Row " + (index + 1))
                    }
                }
            })
            let menuData = new Object()
            menuData["sections"] = sections
            this.menuJsonString = JSON.stringify(menuData,  null, 4)
            jexcel.destroy(this.$refs["spreadsheet"], false)
            this.changeToSheet()
        },
        downloadCSV(){
            if(this.activateIndex === 0){
                this.changeToSheet()
                this.changeToJson()
            }else{
                this.changeToJson()
                this.changeToSheet()
            }
            let csvData = this.changeToCSV(JSON.parse(this.menuJsonString))

            var csvFile;
            var downloadLink;
            let filename = "csv.csv"
            csvFile = new Blob([csvData], {type: "text/csv"});
            downloadLink = document.createElement("a");
            downloadLink.download = filename;
            downloadLink.href = window.URL.createObjectURL(csvFile);
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
            downloadLink.click();
        },
        undoMenu(){
             this.$store.dispatch('apiMenuActiveRevert')
                        .then(({status, res}) => {
                            if(status){
                                Swal.fire(
                                'Undo',
                                'Menu has been undo.',
                                'success')
                                this.getMenuActive()
                            }
                        })
                        .catch(e=>{
                             Swal.fire('Error', e, 'error')
                        })
        },
        publishMenu(){
            this.$store.dispatch('apiMenuActivePublish')
                        .then(({status, res}) => {
                            if(status){
                                Swal.fire(
                                'Published',
                                'Menu has been Published.',
                                'success')
                                this.modified = false
                            }
                        })
                        .catch(e=>{
                             Swal.fire('Error', e, 'error')
                        })
        },
        previewMenu() {
            if(this.activateIndex === 0){
                this.changeToSheet()
                this.changeToJson()
            }else{
                this.changeToJson()
                this.changeToSheet()
            }
            let parseJson = JSON.parse(this.menuJsonString)
            parseJson.sections.forEach(section=>{
                section.items.forEach(item=>{         
                    item._id = this.$HashCode(item.title)        // assign id for cart's options
                });
            })
            this.$store.dispatch('setMenu', parseJson);            
            let routeData = this.$router.resolve({ name: 'Menu Preview' });
            window.open(routeData.href, 'menuPreview');
        },
        onResize() {
            let sheetTab = this.$refs['controllButtons']            
            let navheader = document.getElementById('navheader')            
            if(sheetTab && navheader){
                this.tableWidth = sheetTab.clientWidth - 5;
                this.tableHeight = window.innerHeight - sheetTab.offsetHeight - navheader.offsetHeight - 20;
                this.refresh();
            }
        }       
    },
    mounted(){
        this.getMenuActive()
    }
}
//Remove Double Quote
function rDQ(str){
    if(!str){
        return ""
    }
    var result = str
    if (str.charAt(0) === '"' && str.charAt(str.length -1) === '"') {
       result =  (str.substr(1,str.length -2));
    }
    result = result.replace(/""/g, "\"")
    result = result.replace(/<br\s*[\/]?>/gi, "\"")
    return result
}

function sQD(str){
    if(!str){
        return ""
    }
    var result = str
    
    result = result.replace(/\n/g, "<br />");//replace for New Line

    if(result.indexOf('\"') > -1){
       result = result.replace(/"/g, "\"\"") 
    }
    if(result.indexOf(',') > -1){
       result = '"' + result + '"'
    }

    return result//'"' + result.replace(/"/g, "\"\"") + '"'
}

const daysName = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]
function parseBool(value) {
    if(typeof value === 'boolean'){
        return value
    }
    if (typeof value === "string") {
        value = value.replace(/^\s+|\s+$/g, "").toLowerCase();
        if (value === "true" || value === "false")
        return value === "true";
    }
    throw value + "is not Boolean"; // returns undefined
}
</script>
<style scoped>
    .cell ::v-deep td{
        overflow: hidden;
    }
    .sheet {
        overflow: auto;
        width: 100%;
    }
    .error {
        color: red;
        white-space: pre-wrap;
    }
</style>